export function entraSettings(configuration, origin) {
  if (configuration.authenticationProvider && configuration.authenticationProvider !== "Entra")
    throw new Error("Azure Entra authentication is required.");
  const authority = new URL(configuration.authority);
  const guid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  if (authority.protocol !== "https:" || !authority.hostname.endsWith(".ciamlogin.com") ||
      authority.hostname !== configuration.knownAuthority || authority.username || authority.password ||
      authority.search || authority.hash || authority.port ||
      !(/^\/[0-9a-f-]{36}\/v2\.0$/i.test(authority.pathname) && guid.test(authority.pathname.split("/")[1])) ||
      !guid.test(configuration.clientId) ||
      !/^api:\/\/[0-9a-f-]{36}\/access_as_user$/i.test(configuration.apiScope))
    throw new Error("Invalid Azure Entra configuration.");
  const redirect = new URL(origin);
  if (redirect.origin !== origin || (redirect.protocol !== "https:" &&
      !(redirect.protocol === "http:" && ["localhost", "127.0.0.1", "[::1]"].includes(redirect.hostname))))
    throw new Error("A secure application origin is required.");
  return {
    auth: { clientId: configuration.clientId, authority: authority.href,
      knownAuthorities: [configuration.knownAuthority],
      redirectUri: `${origin}/auth-callback.html`, postLogoutRedirectUri: origin },
    cache: { cacheLocation: "sessionStorage" },
    // Allow email verification and account creation without abandoning the popup.
    system: { windowHashTimeout: 30 * 60 * 1000 },
  };
}
